import { useI18n } from '@oneaudi/i18n-context';
import { Tag, TagGroup } from '@oneaudi/unified-web-components';
import React from 'react';
import { messages } from '../../i18n/messages';
import { transformServicesArray } from '../../utils/transformServices';
import type { Dealer } from '../../interfaces/header-components.interfaces';

const DealerDataServices: React.FC<DealerDataServicesProps> = ({ dealerData }) => {
  /* NOTE: the default English values for 'partnerServiceLabels' from i18n messages.ts have been purposely removed
      as to not cause confusion in non English markets */
  const partnerServiceLabels = new Map<string, string>([
    ['sales', useI18n(messages.sales)],
    ['sales-r8', useI18n(messages.sales_r8)],
    ['service-r8', useI18n(messages.service_r8)],
    ['service', useI18n(messages.service)],
    ['service-noagent', useI18n(messages.service_no_agent)],
    ['etron', useI18n(messages.etron)],
    ['usedcars', useI18n(messages.usedcars)],
    ['aftersales', useI18n(messages.aftersales)],
    ['ovt', useI18n(messages.ovt)],
    ['audi-on-demand', useI18n(messages.audi_on_demand)],
  ]);

  const modifiedServices =
    dealerData !== undefined && dealerData.services.length > 0
      ? transformServicesArray(dealerData.services, partnerServiceLabels)
      : [];
  return (
    <TagGroup data-testid="services-test-id" size="sm">
      {modifiedServices.map((service: string) => (
        <Tag key={service} label={service} variant="read-only" />
      ))}
    </TagGroup>
  );
};

export default DealerDataServices;

interface DealerDataServicesProps {
  dealerData: Dealer;
}
